import cookies from 'react-cookies';
import authRequest from '@ertelecom/ui-react/components/requests/authRequest';
import { billingXMLGetRequest } from '@ertelecom/ui-react/components/requests/billingRequest';
import profileRequest from '@ertelecom/ui-react/components/requests/profileRequest';
import { AGREEMENT_ID_COOKIE, BILLING_GET_INFO, REQUEST_TIMEOUT } from '~/src/constants';

const AGREEMENT_PASSWORD_CHANGE = 'agreement_password_change';

export function login(username, password, rememberMe, domain) {
    const form = new FormData();

    form.append('username', username);
    form.append('password', password);
    form.append('rememberMe', rememberMe ? 1 : 0);

    return authRequest(domain).post('/person/auth', form);
}

export function makeRequest(domain, params, request) {
    const accessToken = 'unauth';
    return profileRequest(domain, accessToken).get(request, {
        params: params,
        timeout: REQUEST_TIMEOUT,
    }).then(response => {
        const data = response.data;
        if (data.code || data.message) {
            return {
                isError: true,
                errorCode: data.code,
                errorMessage: data.message,
                contacts: data.contacts,
            };
        }
        return data;
    });
}

export function getContactList(domain, contact, isActive = true) {
    const params = {
        contact: contact,
        isActive: isActive ? 1 : 0
    };
    const request = '/unauth/contract-asterisked';
    return makeRequest(domain, params, request);
}


export function sendNewPassword(domain, contact) {
    const params = {
        agreement_id: contact.agreementId,
        send_type: contact.contactType,
        id_contact: contact.contactId
    };
    const request = '/unauth/send-agr-sms-email';
    return makeRequest(domain, params, request);
}

export async function changePassword(billingHost, newPassword, accessToken) {
    const agreementId = cookies.load(AGREEMENT_ID_COOKIE).toString();
    const { default: md5 } = await import('blueimp-md5');
    return billingXMLGetRequest(billingHost, accessToken, BILLING_GET_INFO, AGREEMENT_PASSWORD_CHANGE, {
        password: newPassword,
        hex: md5(newPassword + agreementId).toUpperCase()
    });
}
